import awakingImg from '@/static/assets/customer_reviews/pics/tweet_face_awaking.png';
import brentImg from '@/static/assets/customer_reviews/pics/tweet_face_brent.png';
import jakobImg from '@/static/assets/customer_reviews/pics/tweet_face_jakob.png';
import jenniferImg from '@/static/assets/customer_reviews/pics/tweet_face_jennifer.png';
import mariaImg from '@/static/assets/customer_reviews/pics/tweet_face_maria.png';
import rashiqImg from '@/static/assets/customer_reviews/pics/tweet_face_rashiq.png';

export const tweets = [
  {
    name: 'Jakob Wahlers',
    handle: 'jakobwahlers',
    img: jakobImg,
    text: 'Un grand bravo à <span class="primary">@Lemonade_Inc</span> ! Ça n\'a jamais été aussi simple de souscrire un contrat d\'assurance simple et transparent. <span class="primary">#Assurance #Digitalisation #Paperless</span>',
  },
  {
    name: 'Rashiq in SF',
    handle: 'rashiq',
    img: rashiqImg,
    text: "<span class=\"primary\">@Lemonade_Inc</span> Wow c'était de loin la meilleure expérience d'assurance jamais vécue, j'adore votre application.",
  },
  {
    name: 'Brent',
    img: brentImg,
    handle: 'goforbrent',
    text: '<span class="primary">@Lemonade_Inc</span> est l\'assurance la plus simple que je n\'ai jamais achetée, les "vieilles" compagnies d\'assurance doivent se renouveler !!! 👏 👏 👏"',
  },
  {
    name: 'Jennifer Troyer',
    img: jenniferImg,
    handle: 'jennifer_troyer',
    text: "Je viens de découvrir <span class=\"primary\">@Lemonade_Inc</span> et de souscrire. C'était peut-être une des conversation les plus plaisantes que je n'ai jamais eue... J'ai presque envie de recomencer ! Bravo !",
  },
  {
    name: 'Maria Salamanka',
    handle: 'MariaSalamankaM',
    img: mariaImg,
    text: 'Je suis constamment déçue de voir à quel point les assurances se battent avec leurs clients lors des demandes de remboursement. Je viens d\'avoir ma première expérience positive. Une expérience incroyablement rapide et positive <span class="primary">@Lemonade_Inc</span>',
  },
  {
    name: 'AWaking Dream',
    handle: 'AWaking_Dream',
    img: awakingImg,
    text: 'Une fois tous les 2 ou 3 ans, je tombe sur une app / entreprise vraiment exceptionnelle qui réussi à tous les niveaux. UX, prix, service client - <span class="primary">@Lemonade_Inc</span> a tout et j\'adore ça: <span class="primary">www.lemonade.com/fr</span>',
  },
];
